import { isValidAcademyConsentPendingPath } from '~/utils/academyConsentPendingPath';
import log from '~/utils/log';

export default defineNuxtRouteMiddleware((to) => {
    const { $subSectionRegistry } = useNuxtApp();

    if (!isValidAcademyConsentPendingPath($subSectionRegistry.value, to.path, useCountryLanguages())) {
        log.debug(`[validate-academy-consent-pending-path] Aborting navigation for invalid path: ${to.path}`);
        return abortNavigation(createError({ statusCode: 404, statusMessage: 'Academy consent page not found' }));
    }
});
